export default __webpack_public_path__ + "static/fan-illustration-light-1314c1e9bbdf15a6d2348376952f1483.svg";